import {
    TextField,
    useRecordContext,
    ReferenceField,
    NumberField,
    useTranslate,
    usePermissions,
    ListContextProvider,
    useList,
} from "react-admin";
import { Box, Button, CircularProgress } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { RaDeleteButton } from "shared/src/components/buttons/RaDeleteButton";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";

export const ArrivalsList = (props) => {
    const { filter } = props;
    const translate = useTranslate();
    const record = useRecordContext();
    const resource = "arrivals";
    const { isLoading, permissions } = usePermissions();

    const {
        data: arrivals,
        isPending,
        isFetchingNextPage,
        observerRef,
    } = useInfiniteScroll(
        "arrivals",
        {
            filter: {
                product: record?.id,
                ...filter,
            },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "DESC" },
        },
        { enabled: !!record?.id }
    );

    const listContext = useList({ data: arrivals, resource: "arrivals" });

    if (isLoading) {
        return <></>;
    }

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            {permissions.vote({
                resource,
                attribute: "create",
                subject: record,
            }) && (
                <Button
                    onClick={() => props.setDeliveryWindow("edit")}
                    size="small"
                    variant="text"
                    startIcon={<LocalShippingIcon />}
                    title={translate("equip.newDelivery")}
                    aria-label={translate("equip.newDelivery")}
                    sx={{ marginY: 2, marginLeft: 1, display: "flex" }}
                >
                    {translate("equip.newDelivery")}
                </Button>
            )}
            <ListContextProvider value={listContext}>
                <DatagridWithHistory
                    rowClick={(id, _, data) => {
                        props.setDeliveryWindow("show");
                        props.setArrivalData(data);
                        return false;
                    }}
                    bulkActionButtons={false}
                >
                    <TextField label="equip.orderNumber" source="purchaseOrderNumber" />
                    <ReferenceField source="supplier.id" reference="suppliers" link={false}>
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField label="equip.quantity" source="quantity" />
                    <RaDateField label="equip.orderDate" source="orderDate" />
                    <RaDateField label="equip.deliveryDate" source="deliveryDate" />
                    <TextField label="equip.comment" source="comment" />
                    {record.isMassProduct && (
                        <NumberField
                            label="equip.purchasePricePerItem"
                            source="purchasePrice"
                            options={{ style: "currency", currency: "EUR" }}
                        />
                    )}
                    {record.isMassProduct && (
                        <NumberField
                            label="equip.currentPrice"
                            source="currentPrice"
                            options={{ style: "currency", currency: "EUR" }}
                            sortable={false}
                        />
                    )}
                    <RaDeleteButton confirmDelete={true} redirect={false} />
                </DatagridWithHistory>
            </ListContextProvider>
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </Box>
    );
};
